import { render, staticRenderFns, recyclableRender, components } from "./vk-uni-pay.vue?vue&type=template&id=fef57886&scoped=true&"
var renderjs
import script from "./vk-uni-pay.vue?vue&type=script&lang=js&"
export * from "./vk-uni-pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef57886",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/vk-uni-pay/components/vk-uni-pay/vk-uni-pay.vue"
export default component.exports